export default "__VITE_ASSET__BMjAAvJx__"